import { Component } from '@angular/core';

@Component({
  selector: 'lib-new-loading',
  standalone: true,
  imports: [],
  templateUrl: './new-loading.component.html',
  styleUrl: './new-loading.component.css'
})
export class NewLoadingComponent {

}
